'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _adjustScrollingMixin = require('./adjust-scrolling-mixin');

var _adjustScrollingMixin2 = _interopRequireDefault(_adjustScrollingMixin);

var _sectionSubItem = require('./section-sub-item');

var _sectionSubItem2 = _interopRequireDefault(_sectionSubItem);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ApiMenuSectionItem = _react2['default'].createClass({
    displayName: 'ApiMenuSectionItem',


    mixins: [_adjustScrollingMixin2['default']],

    propTypes: {
        title: _react2['default'].PropTypes.string.isRequired,
        reference: _react2['default'].PropTypes.string.isRequired,
        url: _react2['default'].PropTypes.string.isRequired,
        subItems: _react2['default'].PropTypes.array,
        initiallyActiveSubItem: _react2['default'].PropTypes.string,
        isInitiallyActive: _react2['default'].PropTypes.bool,
        isInitiallyExpanded: _react2['default'].PropTypes.bool
    },

    getInitialState: function getInitialState() {
        return {
            'isActive': this.props.isInitiallyActive,
            'isExpanded': this.props.isInitiallyExpanded || this.props.isInitiallyActive,
            'activeSubItem': this.props.initiallyActiveSubItem
        };
    },
    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
        this.setState({
            'isActive': newProps.isInitiallyActive,
            'isExpanded': newProps.isInitiallyExpanded,
            'activeSubItem': newProps.initiallyActiveSubItem
        });
    },
    componentDidUpdate: function componentDidUpdate() {
        this.adjustScrolling();
    },
    expand: function expand() {
        this.setState({
            'isExpanded': !this.state.isExpanded
        });
    },
    render: function render() {

        var arrow = this.props.subItems ? _react2['default'].createElement('span', { className: 'l-api-docs-menu--arrow', onClick: this.expand }) : null;

        var classes = (0, _classnames2['default'])({
            'l-api-docs-menu--items--item': true,
            'is-active': this.state.isActive,
            'is-expanded': this.state.isActive || this.state.isExpanded,
            'is-expandable': this.props.subItems && this.props.subItems.length > 0
        });

        var subItems = this.props.subItems ? this.props.subItems.map(function (subItem) {

            var isActive = this.state.activeSubItem != null && this.state.activeSubItem.toLowerCase() == subItem.reference.toLowerCase();

            return _react2['default'].createElement(_sectionSubItem2['default'], {
                key: 'sub_item_' + subItem.reference,
                title: subItem.title,
                reference: subItem.reference,
                url: subItem.url,
                isInitiallyActive: isActive });
        }.bind(this)) : null;

        return _react2['default'].createElement(
            'div',
            { className: classes, 'data-ref': this.props.reference },
            arrow,
            _react2['default'].createElement(
                'a',
                { href: this.props.url },
                this.props.title
            ),
            subItems && subItems.length ? _react2['default'].createElement(
                'div',
                { className: 'l-api-docs-menu--sub-items' },
                subItems
            ) : null
        );
    }
});

module.exports = ApiMenuSectionItem;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api-docs/api-menu/section-item.jsx
 ** module id = 865
 ** module chunks = 0
 **/